// Libraries
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 37px 0px; 
  background-color: ${({ theme }) => theme.colors.blueDarkerDefault};
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-size: ${({ theme }) => theme.fontSize.small};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.white00};
`

export const LogoDiv = styled.div`
  margin-left: 40px;
  margin-bottom: 44px;
`

export const EmailSocialDiv = styled.div`
  width: 50%;
`

export const NavDiv = styled.div`
  margin: 42px 0px 65px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    width: 50%;
    flex-direction: row;
    margin: 14px 0px;
  }
`

export const NavSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const SectionTitle = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.lato};
  font-size: ${({ theme }) => theme.fontSize.small};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.gray03};
  margin-bottom: 22px;
`

export const SectionOptions = styled.div`
  line-height: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const SocialDiv = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    width: 152px;
    margin-top: 40px;
  }
`

export const GoBack = styled.button`
  border: none;
  position: absolute;
  top: 100%;
  left: 0px;
  width: 100%;
  padding: 18px 0px;
  background-color: ${({ theme }) => theme.colors.gray08};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.fontFamily.lato};
  font-size: ${({ theme }) => theme.fontSize.small};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.gray03};
  cursor: pointer;
`

export const CompanyInfo = styled.address`
  margin-top: 30px;
  font-style: normal;
  font-size: ${({ theme }) => theme.fontSize.xsmall};
  line-height: 22px;
  color: ${({ theme }) => theme.colors.gray05};
  p {
    margin: 0;
  }
`
